import styles from "./Navbar.module.scss";
import { NavLink, useLocation } from 'react-router-dom';
import classNames from "classnames";
import { ModeContext } from "../../context/ModeContext";
import HomeImage from "../../styles/nav_images/home.jpeg"
import LibraryImage from "../../styles/nav_images/library.jpg"
import ProgressImage from "../../styles/nav_images/progress.jpg"
import PerformanceImage from "../../styles/nav_images/performance.jpg"
import BenchmarkImage from "../../styles/nav_images/benchmark.jpg"
import LearningImage from "../../styles/nav_images/learning.jpeg"
import AnalysisImage from "../../styles/nav_images/analysis.jpg"
import { useContext } from "react";
import { APPLICATION_TYPE } from '../../enums/application';
import { ReactComponent as HomeLogo } from '../../styles/nav_icons/home.svg';
import { ReactComponent as ScanLogo } from '../../styles/nav_icons/analysis.svg';
import { ReactComponent as LibraryLogo } from '../../styles/nav_icons/library_books.svg';
import { ReactComponent as ProgressLogo } from '../../styles/nav_icons/monitoring.svg';
import { ReactComponent as DashboardLogo } from '../../styles/nav_icons/dashboard.svg';
import { ReactComponent as BenchmarkLogo } from '../../styles/nav_icons/benchmark_icon.svg';
import { ReactComponent as ResourceLogo } from '../../styles/nav_icons/school.svg';
import { ReactComponent as AccountLogo } from '../../styles/nav_icons/user.svg';
import { UserContext } from '../../context/UserContext';
import { Features } from '../../apollo/types/features';


type isActiveLinkProps = {
  isActive: boolean;
};

type NavBarProps = {
  active?: boolean;
};

enum Routes {
    HOME = '/library/home',
    SCANS = '/library/scans',
    STARTUPS = '/library/startups',
    REVIEW = '/library/review',
    PORTFOLIODASHBOARD = '/library/portfoliodashboard',
    DASHBOARD = '/library/minimal-dashboard',
    BENCHMARK = '/library/benchmark',
    LEARNING = '/library/learning',
    ORGANISATIONS = '/admin/organisations',
    TEST = '/admin/test/report',
    PROGRESS = '/library/progress',
    ACCOUNT = '/Account'
}

// @ts-ignore
const getMainImage = (path:string, userContext) => {
    switch(path) {
        case Routes.HOME:
            return <img className={styles.image} src={HomeImage}/>;
        case Routes.STARTUPS:
            return <img className={styles.image} src={LibraryImage}/>;
        case Routes.SCANS:
            return <img className={styles.image} src={AnalysisImage}/>;
        case Routes.REVIEW:
            return <img className={styles.image} src={ProgressImage}/>;
        case Routes.PORTFOLIODASHBOARD:
            return <img className={styles.image} src={PerformanceImage}/>;
        case Routes.BENCHMARK:
            return <img className={styles.image} src={BenchmarkImage}/>;
        case Routes.LEARNING:
            return <img className={styles.image} src={LearningImage}/>;
        default:
            return <img className={styles.image} src={AnalysisImage}/>;
    }
}

const isActiveLink = ({ isActive }: isActiveLinkProps): string =>
  isActive ? styles.activeLink : styles.link;

export const NavBartStartupLib = ({ active }: NavBarProps) => {
  const { adminMode } = useContext(ModeContext);
  const userContext = useContext(UserContext)
  const location = useLocation();
  const isSuperAdmin = userContext?.organisation?.id === 1;
  const isAdmin = userContext?.role === "ADMIN";
  const isStartup = userContext?.role === "STARTUP";

  let portfolioDashboard = false
  let dataDashboard = false
  if(userContext.organisation?.features?.length) {
     for (const feature of userContext.organisation.features) {
        if(feature.name === Features.PORTFOLIO_DASHBOARD && feature.status === 'ENABLED') {
            portfolioDashboard = true;
        }
         if(feature.name === Features.DATA_DASHBOARD && feature.status === 'ENABLED') {
             dataDashboard = true;
         }
     }
  }

    return (
    <aside className={classNames(styles.aside, { [styles.active]: !active })}>
      <div className={styles.imageWrapper}>
          { process.env.REACT_APP_APPLICATION_TYPE === APPLICATION_TYPE.STARTUP_LIBRARY &&
              getMainImage(location.pathname, userContext)
          }
      </div>
      <nav className={styles.nav}>
          {/*{*/}
          {/*    (isSuperAdmin || portfolioDashboard) &&*/}
          {/*    <>*/}
          {/*    <NavLink to={Routes.HOME} className={isActiveLink}>*/}
          {/*        <HomeLogo className={styles.icon}/>*/}
          {/*        <span>Home</span>*/}
          {/*    </NavLink>*/}
          {/*    </>*/}
          {/*}*/}
          <NavLink to={Routes.STARTUPS} className={isActiveLink}>
              <LibraryLogo className={styles.icon}/>
              <span>Library</span>
          </NavLink>
        <NavLink to={Routes.SCANS} className={isActiveLink}>
            <ScanLogo className={styles.icon}/>
            <span>Analysis</span>
        </NavLink>
          <NavLink to={Routes.REVIEW} className={isActiveLink}>
              <ProgressLogo className={styles.icon}/>
              <span>Review</span>
          </NavLink>
          {
              (isSuperAdmin || dataDashboard) &&
              <NavLink to={Routes.DASHBOARD} className={isActiveLink}>
                  <DashboardLogo className={styles.icon}/>
                  <span>Data Dashboard</span>
              </NavLink>
          }
          <NavLink to={Routes.LEARNING} className={isActiveLink}>
              <ResourceLogo className={styles.icon}/>
              <span>Learning</span>
          </NavLink>
          {
              (isSuperAdmin || portfolioDashboard) &&
              <>
                  <hr />
                  <NavLink to={Routes.PORTFOLIODASHBOARD} className={isActiveLink}>
                      <DashboardLogo className={styles.icon}/>
                      <span>Portfolio Dashboard</span>
                  </NavLink>
                  <NavLink to={Routes.BENCHMARK} className={isActiveLink}>
                      <BenchmarkLogo className={styles.icon}/>
                      <span>Benchmark</span>
                  </NavLink>
              </>
          }
          {
              isSuperAdmin &&
              <>
                  <NavLink to={Routes.ACCOUNT} className={isActiveLink}>
                      <AccountLogo className={styles.icon}/>
                      <span>Account</span>
                  </NavLink>
                  <NavLink to={Routes.ORGANISATIONS} className={isActiveLink}>
                      <LibraryLogo className={styles.icon}/>
                      <span>Manage Organisations</span>
                  </NavLink>
              </>
          }
        <NavLink to='/'  className={styles.hiddenLink}></NavLink>
      </nav>
    </aside>
  );
};
